import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaTop, WeaTab,WeaRightMenu,WeaErrorPage,WeaSearchGroup,WeaFormItem,WeaSelect,WeaAlertPage,} from 'ecCom';
import {Row,Col,Button} from 'antd';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
const toJS = mobx.toJS;
import * as PublicFunc from '../util/pulic-func';
window.openFullWindowForXtable = PublicFunc.openFullWindowForXtable;
import moment from 'moment';
import {WeaTableNew,WeaSwitch} from 'comsMobx';
import {i18n} from '../public/i18n';
const WeaTable = WeaTableNew.WeaTable;
let _this;

@inject('hrmTrainRecord')

@observer
class HrmTrainRecord extends React.Component {
  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['onOperatesClick'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
    this.changeTab('1');
  }
  
  componentWillReceiveProps(nextProps) {
    if(this.props.location.key !== nextProps.location.key) {
      this.changeTab('1');
    }
  }

  render(){
    const { hrmTrainRecord } = this.props;
    let {title,form,table,showSearchAd,searchParamsAd,tabkey,tabDatas} = hrmTrainRecord;
    tabDatas = toJS(tabDatas);

    const {query} = this.props.location;
    const formParams = form.getFormParams();
    return (
      <div className='wea-myhrm-Trainrecord'>
      <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
        <div style={query.fromcard? {display:'none'} :  {display:''}}>
          <WeaTop
            title={title()}
            icon={<i className='icon-coms-hrm' />}
            iconBgcolor='#217346'
            buttons={[]}
            buttonSpace={10}
            showDropIcon={false}
          />
        </div>
        <WeaTab
          selectedKey={tabkey}
          datas={[{title: i18n.module.trainRecord(), key:"1"}, {title: i18n.label.trainingArrangements(), key:"2"}]}
          keyParam='key'
          selectedKey={tabkey}
          onChange={this.changeTab.bind(this)}
          buttonsAd={this.getTabButtonsAd()}
          searchType={['base','advanced']}
          searchsBaseValue={formParams.planname}
          setShowSearchAd={bool => {hrmTrainRecord.setShowSearchAd(bool)}}
          hideSearchAd={() => hrmTrainRecord.setShowSearchAd(false)}
          searchsAd={this.getSearchs()}
          showSearchAd={showSearchAd}
          onSearch={v => {hrmTrainRecord.doSearch()}}
          onSearchChange={v => {
            form.updateFields({
                planname:{name:'planname',value:v},
              });
            }}
        />
        <WeaTable
          comsWeaTableStore={table}
          hasOrder={true}
          needScroll={true}
          //onOperatesClick={this.onOperatesClick}
          />
        </WeaRightMenu>
      </div>
    );
  }

  changeTab(key) {
    const {hrmTrainRecord} = this.props;
    hrmTrainRecord.changeTab(key);
  }

  getSearchs() {
    const { hrmTrainRecord } = this.props;
    const { form,condition } = hrmTrainRecord;
    const {isFormInit} = form;
    let group = [];

    const formParams = form.getFormParams();

    isFormInit && toJS(condition).map(c =>{
      let items = [];
      c.items.map(fields => {
        let hide = false;
        let dom =  <WeaSwitch fieldConfig={fields} form={form} formParams={formParams}/>;
        items.push({
          com:(<WeaFormItem
              label={`${fields.label}`}
              labelCol={{span: `${fields.labelcol}`}}
              wrapperCol={{span: `${fields.fieldcol}`}}>
                {dom}
              </WeaFormItem>),
          colSpan:1,
          hide: hide
        })
      });
      group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
    });
    return group;
  }

  onOperatesClick=(record,index,operate,flag,argumentString)=>{
    const { hrmTrainRecord } = this.props;
    const { condition } = hrmTrainRecord;
    const fn = operate.href ? operate.href.split(':')[1].split('(')[0] : '';
    const id = record.id ? record.id : '';
    const applyworkflowid = !isEmpty(toJS(condition)) && toJS(condition)[0].applyworkflowid
    if(fn && fn=='jsHrmTrainApply'){
      PublicFunc[fn](id,applyworkflowid);
    }else{
      PublicFunc[fn](id);
    }
  }

  getRightMenu(){
    const keys = this.getSelectedRowKeys();
    const arr = [{
        icon: <i className='icon-coms-ws'/>,
        content: i18n.button.search()
      }, {
        icon: <i className='icon-coms-task-list'/>,
        content: i18n.button.columnVisibleSetting()
      }
    ];
    return arr;
  }

  onRightMenuClick(key){
    const { hrmTrainRecord } = this.props;
    switch(key){
        case '0':
            hrmTrainRecord.doSearch();
            break;
        case '1':
            this.definedColumn();
            break;
    }
  }

  getSelectedRowKeys(){
    const { hrmTrainRecord } = this.props;
    const { table} = hrmTrainRecord;
    const selectedRowKeys = table.selectedRowKeys;
    return selectedRowKeys;
  }

  definedColumn() {
    const { hrmTrainRecord } = this.props;
    const { table} = hrmTrainRecord;
    table.setColSetVisible(true);
    table.tableColSet(true);
  }

  getTabButtonsAd() {
    const { hrmTrainRecord } = this.props;
    const { form,searchParamsAd } = hrmTrainRecord;
    return [
        (<Button type="primary" onClick={()=>{hrmTrainRecord.doSearch();hrmTrainRecord.setShowSearchAd(false)}}>{i18n.button.search()}</Button>),
        (<Button type="ghost" onClick={()=>{form.reset();}}>{i18n.button.reset()}</Button>),
        (<Button type="ghost" onClick={()=>{hrmTrainRecord.setShowSearchAd(false)}}>{i18n.button.cancel()}</Button>)
    ]
  }
}

export default HrmTrainRecord



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/TrainRecord.js